module.exports = __webpack_public_path__ + "static/media/object-group.0e99129f.svg";